import { Expose } from 'class-transformer';

export class CardPointsToExpireApiModel {
  @Expose()
  expiryDate: string;

  @Expose()
  points: number;
}
